import {Link} from "@tanstack/react-router";
import NewListedItem from './NewListedItem'
import ITag from '../ITag'
import {useEffect, useRef, useState} from "react";
import { getAllItems } from '../../lib/api';
//import {cleanUrl, ipfs2md5} from "../../utils/Sections.jsx";

/**
 * SecNewListed - Grid of newly listed NFT items
 *
 * Fetches all available NFTs (not necessarily auctions) via Backend('all')
 * and displays them using NewListedItem components. Supports pagination
 * with "Show Newer" and "Show Older" buttons that update the offset.
 * Can accept initial data from route loader for SSR.
 *
 * @param {Array} props.initialItems - Pre-fetched items from loader (optional)
 * @param {string|number} props.rerender - Trigger to force refresh (passed to children)
 * @param {string} props.searchParam - Search filter parameter (passed to backend)
 * @param {string} props.net - Network filter; "any" means all networks
 * @returns {React.ReactElement} Rendered new listings grid with pagination
 */

function SecNewListed({ initialItems = [] }){
    const [newListed, setNewListed]=useState(initialItems);
    const [offset, setOffset]=useState(0);
    const [iCount, setIC] = useState(initialItems.length);
    const isFirstRender = useRef(true);
  //  let navButtons = "";
    const navLinks = (type) => {
        if(type==="newer"){
            if (offset > 0) {
                return (<Link className="btn bg-gradient-dark mb-0" onClick={() => {setOffset(offset - 12);executeScroll()}} to="#">
                    <ITag ClassName="fas fa-plus mr-10"/>Show Newer</Link>)
            }
        } else if(type==="older"){
            if (iCount === 12) {
                return(<Link className="btn bg-gradient-dark mb-0" onClick={() => {setOffset(offset + 12);executeScroll()}} to="#">
                    <ITag ClassName="fas fa-plus mr-10"/>Show Older</Link>)
            }
        } else {
            return null
        }
    }

    useEffect(() => {
        // Skip fetch on first render if we have initial data from loader
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (initialItems.length > 0) {
                return;
            }
        }

        // Fetch data for the current offset (initial load if no initial data, or pagination)
        getAllItems({ from: offset }).then((result) => {
            setNewListed(result.data);
            setIC(result.data.length);
        }).catch(err => {
            console.error('Failed to fetch items:', err);
            setNewListed([]);
            setIC(0);
        });
    }, [offset])

    const topRef = useRef(null);
    const executeScroll = () => topRef.current.scrollIntoView({ behavior: 'instant', block: 'start' })

    return(
      <div className="container-fluid" ref={topRef}>
        <div className="col-12 py-0">
          <div className="card">

            <div className="card-body p-3">
              <div className="row">
                {newListed && newListed.map((item , i) => (


                    <NewListedItem
                        key={i}
                        // path1 prop is now computed inside NewListedItem using full.network or default
                      //    /* paths should be generated on the fly*/}
                      //   path3={item.path3      /* rather than being fetched from the db*/}
                      //   path4={item.path4}
                      //   path5={item.path5}
                      //   path6={item.path6}
                      //   path7={item.path7}
                      //   path8={item.path8}
                        img1={item.aImageURI}       /* these should be text fields only, not */
                        // img2={item.img2       /* embedded images, as embedded can't be */}
                        // img3={item.img3       /* cached, plus makes db calls much slower */ }
                        // img4={item.img4}
                        // img5={item.img5}
                        // img6={item.img6}
                        text1={item.text1}
                        text2={item.text2}
                        price={item.price}
                        isCached={item.isCached}
                        full={item}
                    />

                ))}

                <div id="nav1" className="col-md-12 text-center">
                    {navLinks("newer")}&nbsp;{navLinks("older")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default SecNewListed
